import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCall"><Path d="M10 8L9 3.5H6.85091H3.50194C3.50065 3.5857 3.5 3.67156 3.5 3.75758C3.5 6.81476 4.31941 9.68055 5.75058 12.1473C7.21688 14.6747 9.32535 16.7831 11.8527 18.2494C14.3194 19.6806 17.1852 20.5 20.2424 20.5H20.5V15L16 14L14.2582 15.7436C11.666 14.4469 9.55309 12.334 8.25636 9.74177L10 8Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCall;
